// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3067) return "static/chunks/3067.3aa6f21dc38d3ea5.js";
	if (chunkId === 5231) return "static/chunks/5231.577361b4f04717b5.js";
	if (chunkId === 1479) return "static/chunks/1479.0ece4034c16e3220.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2537":"4cdf4c346ea00efc","4694":"3f3f8bf41e6d8877","6591":"e5c1f0f755525cff","8480":"ca6b8588b71a089e","9552":"f020e9f69c73fd29","9647":"874a8966b6704bd2"}[chunkId] + ".js";
};